import { Expose } from "class-transformer";

export class AskQuestionDto {
  @Expose()
  question: string;

  @Expose()
  conversationId?: string;
}
